import { bus } from '@core/events/eventSystem';
import constants from './constants';

/**
 * Proxy pour les requêtes eSIM via le batch proxy
 * L'API eSIM Access nécessite le header RT-AccessCode
 */
async function esimProxyRequest(url, method = 'GET', data = null) {
  const requestId = `esim-${Date.now()}-${Math.random().toString(36).substring(7)}`;

  const batchPayload = {
    requests: [
      {
        id: requestId,
        url: url,
        method: 'POST',
        headers: {
          'RT-AccessCode': constants.ENDPOINTS.ESIM.ACCESS_CODE,
          'Content-Type': 'application/json'
        }
      }
    ],
    options: {
      parallel: true
    }
  };

  // Pour les requêtes avec données (POST original), ajouter le body
  // Pour les requêtes GET originelles, envoyer un objet vide pour éviter "request json invalid"
  if (data) {
    batchPayload.requests[0].body = data;
  } else {
    batchPayload.requests[0].body = {};
  }

  console.log('esimProxyRequest:', { url, method, requestId });

  try {
    const response = await fetch(constants.ENDPOINTS.ESIM.PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(batchPayload)
    });

    const result = await response.json();
    console.log('esimProxyResponse:', result);

    if (result.success && result.responses && result.responses[0]) {
      const responseObj = result.responses[0];
      // La réponse de l'API eSim est dans responseObj.data
      return responseObj.data || responseObj;
    }

    throw new Error(result.message || 'Proxy batch request failed');
  } catch (error) {
    console.error('esimProxyRequest error:', error);
    throw error;
  }
}

// Fetch countries
bus.on(constants.EVENTS.ESIM.FETCH_COUNTRIES, async () => {
  try {
    const result = await esimProxyRequest(
      constants.ENDPOINTS.ESIM.BASE + constants.ENDPOINTS.ESIM.COUNTRIES
    );

    // result is responseObj.data which contains {success: true, obj: {locationList: [...]}}
    if (result.success && result.obj && result.obj.locationList) {
      bus.emit(constants.EVENTS.ESIM.FETCH_COUNTRIES_SUCCESS, result.obj.locationList);
    } else {
      bus.emit(constants.EVENTS.ESIM.FETCH_COUNTRIES_ERROR, result.errorMsg || 'Error fetching countries');
    }
  } catch (error) {
    console.error('Error fetching eSim countries:', error);
    bus.emit(constants.EVENTS.ESIM.FETCH_COUNTRIES_ERROR, error);
  }
});

// Fetch packages for a location
bus.on(constants.EVENTS.ESIM.FETCH_PACKAGES, async (locationCode) => {
  if (!locationCode) {
    bus.emit(constants.EVENTS.ESIM.FETCH_PACKAGES_ERROR, 'Location code is required');
    return;
  }

  try {
    const result = await esimProxyRequest(
      constants.ENDPOINTS.ESIM.BASE + constants.ENDPOINTS.ESIM.PACKAGES,
      'POST',
      {
        locationCode: locationCode,
        type: constants.PACKAGE_TYPES.BASE
      }
    );

    // result is responseObj.data which contains {success: true, obj: {packageList: [...]}}
    if (result.success && result.obj && result.obj.packageList) {
      bus.emit(constants.EVENTS.ESIM.FETCH_PACKAGES_SUCCESS, result.obj.packageList);
    } else {
      bus.emit(constants.EVENTS.ESIM.FETCH_PACKAGES_ERROR, result.errorMsg || 'Error fetching packages');
    }
  } catch (error) {
    console.error('Error fetching eSim packages:', error);
    bus.emit(constants.EVENTS.ESIM.FETCH_PACKAGES_ERROR, error);
  }
});

// Create order
bus.on(constants.EVENTS.ESIM.CREATE_ORDER, async (orderData) => {
  // Expected orderData format:
  // {
  //   transactionId: string,
  //   packageCode: string,
  //   amount: number,
  //   email: string
  // }

  if (!orderData || !orderData.transactionId || !orderData.packageCode) {
    bus.emit(constants.EVENTS.ESIM.CREATE_ORDER_ERROR, 'Invalid order data');
    return;
  }

  try {
    const payload = {
      transactionId: orderData.transactionId,
      amount: orderData.amount,
      packageInfoList: [
        {
          packageCode: orderData.packageCode,
          count: 1,
          price: orderData.amount
        }
      ]
    };

    const result = await esimProxyRequest(
      constants.ENDPOINTS.ESIM.BASE + constants.ENDPOINTS.ESIM.ORDER,
      'POST',
      payload
    );

    // result is responseObj.data which contains {success: true, obj: {...}}
    if (result.success && result.obj) {
      const orderResult = result.obj;
      bus.emit(constants.EVENTS.ESIM.CREATE_ORDER_SUCCESS, {
        orderNo: orderResult.orderNo,
        transactionId: orderData.transactionId,
        email: orderData.email
      });
    } else {
      bus.emit(constants.EVENTS.ESIM.CREATE_ORDER_ERROR, result.errorMsg || 'Error creating order');
    }
  } catch (error) {
    console.error('Error creating eSim order:', error);
    bus.emit(constants.EVENTS.ESIM.CREATE_ORDER_ERROR, error);
  }
});
